import React from "react";
import T from "prop-types";
import { shortDateAndTimestamp } from "LIB/formatters/date";

export default function QuotedPartWarning({
  quote_created_at: quoteCreatedAt,
  quote_contact: quoteContactName,
  quoted_company: quotedCompany,
  quoter: aeroZoneEmployee,
  quoted_part_type: quotedPartType
}) {
  return (
    <div className="center-block alert alert-iq">
      <div className="media">
        <div className="media-left">
          <i className="fa fa-lg fa-warning text-warning" />
        </div>
        <div className="media-body">
          In the last 14 days, this part number was{" "}
          {quotedPartType === "no_quote" ? "no quoted" : "quoted"} to{" "}
          {aeroZoneEmployee} by {quoteContactName} at {quotedCompany} on{" "}
          {shortDateAndTimestamp(quoteCreatedAt)}. Please consider contacting{" "}
          {aeroZoneEmployee}. *Please be careful quoting as they might be
          pricing us.
        </div>
      </div>
    </div>
  );
}

QuotedPartWarning.propTypes = {
  quoter: T.string.required,
  quoted_company: T.string.required,
  quote_contact: T.string.required,
  quote_created_at: T.string.required
};



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/shared/QuotedPartWarning.jsx